import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { render } from "@react-email/render";
import { requireAdmin } from "@/lib/admin-guard";
import { DRAFT_EMAILS } from "@/lib/email-redesign/templates";

export const Route = createFileRoute("/admin_/email-review")({
  ssr: false,
  head: () => ({ meta: [{ title: "Email redesign review — Admin" }, { name: "robots", content: "noindex,nofollow" }] }),
  beforeLoad: requireAdmin,
  component: EmailReview,
});

function EmailReview() {
  const [id, setId] = useState(DRAFT_EMAILS[0].id);
  const [dark, setDark] = useState(false);
  const [html, setHtml] = useState("");
  const email = DRAFT_EMAILS.find((e) => e.id === id)!;
  useEffect(() => {
    let live = true;
    void render(email.el).then((h) => {
      if (!live) return;
      setHtml(dark ? h.replace("<head>", "<head><style>:root{color-scheme:dark}</style>") : h);
    });
    return () => { live = false; };
  }, [email, dark]);
  const groups = [...new Set(DRAFT_EMAILS.map((e) => e.group))];
  return (
    <div className="mx-auto max-w-6xl p-4 md:p-8">
      <h1 className="text-2xl font-semibold text-foreground">Email redesign — review (not live)</h1>
      <p className="mt-1 text-sm text-muted-foreground">Drafts only. Nothing here is sent until approved.</p>
      <div className="mt-6 grid gap-6 md:grid-cols-[280px_1fr]">
        <nav className="space-y-4">
          {groups.map((g) => (
            <div key={g}>
              <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{g}</p>
              {DRAFT_EMAILS.filter((e) => e.group === g).map((e) => (
                <button key={e.id} onClick={() => setId(e.id)}
                  className={`mt-1 block w-full rounded-lg px-3 py-2 text-left text-sm ${e.id === id ? "bg-primary text-primary-foreground" : "text-foreground hover:bg-muted"}`}>
                  {e.name}
                </button>
              ))}
            </div>
          ))}
        </nav>
        <section>
          <div className="rounded-xl border border-border bg-card p-4 text-sm text-card-foreground">
            <p><strong>Subject:</strong> {email.subject}</p>
            <p className="mt-1"><strong>Sent when:</strong> {email.trigger}</p>
            <p className="mt-1"><strong>Style:</strong> {email.tone}</p>
            <label className="mt-3 flex items-center gap-2"><input type="checkbox" checked={dark} onChange={(e) => setDark(e.target.checked)} /> Preview in dark mode</label>
          </div>
          <div className="mt-4 flex justify-center">
            <iframe title={email.name} srcDoc={html} className="h-[760px] w-[390px] rounded-3xl border-8 border-foreground/80 bg-background" style={{ colorScheme: dark ? "dark" : "light" }} />
          </div>
        </section>
      </div>
    </div>
  );
}
